import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';

dayjs.extend(isoWeek);
dayjs.extend(quarterOfYear);

export { dayjs };

export const utils = {
    firstKey(obj) {
        let k = Object.keys(obj);
        return k.length ? k[0] : null;
    },
    replaceKey(obj, keyOld, keyNew) {
        obj[keyNew] = obj[keyOld];
        if (keyOld != keyNew) {
            delete obj[keyOld];
        }
        return obj;
    }
};

/**
 * @private Returns method url
 * @param {string} host
 * @return {string}
 */
export const buildBaseURL = ({ host }) => `${host}/api`;

/**
 * @param {string} [authToken]
 * @param {boolean} [admin]
 * @param {string} [connection]
 * @return {{}}
 */

export const buildRequestHeaders = ({ authToken, admin }) => {
    const headers = {};

    if ([ undefined, null, '' ].includes(authToken) === false) {
        headers['Authorization'] = `Bearer ${authToken}`;
        headers['token'] = authToken;
    }
    if (admin === true) {
        headers['x-dremio-admin'] = 1;
    }

    return headers;
};

/**
 * @private
 * @param {Function} func
 * @return {Promise}
 */
export const hook = func => {
    return func ? Promise.resolve(func()) : Promise.resolve();
};

/**
 * @param {{ url: string, options?: { method?: string } }} action
 * @param {Record<string, string|number>} [pathParams]
 * @param {Record<string, any>} [params]
 * @param {Record<string, string|number|boolean|null>} [queryParams]
 * @param {Record<string, any>} [options]
 * @return {{ url: string, method: string, params?: Record<string, string|number|boolean>, data?: Record<string, any>, options: Record<string, any> }}
 */
export const buildRequestConfig = ({
       action,
       pathParams = {},
       params = {},
       queryParams,
       options = {}
   }) => {
    const {
        url: initialUrl = '',
        options: defaultOptions = {},
        params: defaultParams,
        data: defaultData
    } = action;
    const url = Object.entries(pathParams).reduce(
        (finalUrl, [ key, value ]) => finalUrl.replace(new RegExp(`:${key}`, 'g'), String(value)),
        initialUrl
    );
    // @NOTE this should be removed in the future (buildBaseURL() method)
    const {
        baseURL: host,
        method
    } = defaultOptions;
    if (host != null) {
        defaultOptions.baseURL = buildBaseURL({ host });
    }

    const mergedOptions = {
        ...defaultOptions,
        ...options,
        params: {
            ...defaultParams,
            ...queryParams,
            ...options.params
        },
        data: {
            ...defaultData,
            ...options.data
        }
    };

    return {
        url,
        ...(method && { method }),
        params,
        options: mergedOptions
    };
};
